export default __webpack_public_path__ + "static/media/CircleLogo.2ecd518a.png";